export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["确认"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["是"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您确定要继续吗？"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["删除加密资产"])}
}